export default "__VITE_ASSET__3c23c2dd__"